import React from 'react';

/**
 * QuestionForm component renders a form to submit questions in different languages.
 * 
 * @param {Array} languages - The languages to create the question in.
 * @param {function} onSubmit - Function to handle form submission.
 * @param {number} itemID - The ID of the item to associate the question with.
 * @returns {JSX.Element} A form element for submitting questions.
 */
export const QuestionForm = ({ languages, onSubmit, itemID }) => {

     /**
     * Handles the form submission event.
     */
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.target);
        const questiontype = data.get('questiontype');
        onSubmit(data, itemID, questiontype);
    };

    return (
        <div>
            <form id="form" onSubmit={handleSubmit} method="post" className="question-form">
                <div className="form-group">
                    <input name="questiontype" type="text" className="form-control" id="questiontype" placeholder="Vad är det för frågetyp?" />

                    {languages.map((props) => (
                        <div key={props.id} className="question-form-section" >
                            <label>{props.languageText}</label>
                            <input type="number" name={`questionList[${props.id - 1}].LanguageId`} value={props.id} readOnly style={{ display: "none" }} />
                            <input name={`questionList[${props.id - 1}].TextUrl`} type="text" className="form-control" id="textUrl" placeholder="Text" />
                            <input name={`questionList[${props.id - 1}].AudioFile`} type="file" className="form-control" id="audioUrl" />
                            <input name={`questionList[${props.id - 1}].VideoFile`} type="file" className="form-control" id="videoUrl" />
                        </div>
                    ))}
                </div>
                <button type="submit" className="btn btn-primary">Skapa</button>
            </form>
        </div>
    );
};
